<template>
  <!-- Multi-City Toggle -->
  <v-radio-group v-model="form.tripType">
    <v-row class="align-center mt-4" no-gutters>
      <v-col cols="5" md="3" class="multi-city-toggle mr-3" :class="$display.smAndDown ? 'mr-2' : 'mr-3'">
        <label class="toggle-switch">
          <v-radio label="One Way" value="1"></v-radio>
        </label>
      </v-col>
      <v-col cols="6" md="3" class="multi-city-toggle" :class="$display.smAndDown ? 'mr-2' : 'mr-3'">
        <label class="toggle-switch">
          <v-radio label="Round Trip" value="2"></v-radio>
        </label>
      </v-col>
      <v-col cols="5" md="3" class="multi-city-toggle">
        <label class="toggle-switch">
          <v-radio label="Multi City" value="3"></v-radio>
          <!-- <input
        type="checkbox"
        id="multi-city-toggle"
        v-model="isMultiCityEnabled"
        @change="toggleMultiCityMode"
      />
      <span class="toggle-slider"></span>
      <span class="toggle-label">Multi-City</span> -->
        </label>
      </v-col>
    </v-row>
  </v-radio-group>


  <!-- Standard ONE WAY / ROUND TRIP -->
  <v-row class="standard-trip-options" :class="{ hidden: isMultiCityEnabled }" id="standard-trip-options">
    <!-- From -->
    <v-col cols="12" sm="6" :md="form.tripType == 2 ? '6' : '4'">
      <v-autocomplete v-model="form.sourceAddress" :items="pickupSuggestions" :loading="pickupLoading"
        :list-props="{ class: 'custom-list', maxWidth: form.tripType == 2 ? 590 : 385 }" label="From"
        placeholder="Enter Pickup Location" variant="outlined" hide-no-data no-filter item-title="description"
        item-value="place_id" @update:search="fetchPickupSuggestions" @update:modelValue="onPickupSelected"
        return-object>
        <template #prepend-inner>
          <v-icon style="color: #005886">mdi-map-marker</v-icon>
        </template>
      </v-autocomplete>
    </v-col>

    <!-- To -->
    <v-col cols="12" sm="6" :md="form.tripType == 2 ? '6' : '4'">
      <v-autocomplete v-model="form.destinationAddress" :items="dropSuggestions" :loading="pickupLoading"
        :list-props="{ class: 'custom-list', maxWidth: form.tripType == 2 ? 590 : 385 }" label="To"
        placeholder="Enter Drop Location" variant="outlined" hide-no-data no-filter item-title="description"
        item-value="place_id" @update:search="fetchDropSuggestions" @update:modelValue="onDropSelected" clearable
        return-object>
        <template #prepend-inner>
          <v-icon style="color: #005886">mdi-map-marker</v-icon>
        </template>
      </v-autocomplete>
    </v-col>

    <!-- Date -->
    <v-col cols="12" sm="6" :md="form.tripType == 2 ? '3' : '2'">
      <v-menu v-model="menuDate" :close-on-content-click="false" transition="scale-transition" offset-y
        min-width="auto">
        <template #activator="{ props }">
          <v-text-field v-model="formattedOutstationDate" label="Departure Date" readonly v-bind="props"
            variant="outlined" color="#005886" required>
            <template #prepend-inner>
              <v-icon style="color: #005886">mdi-calendar</v-icon>
            </template>
          </v-text-field>
        </template>
        <v-date-picker v-model="form.startDate" :min="getTodayLocal()" @update:modelValue="onDateSelected"
          hide-actions />
      </v-menu>
    </v-col>
    <v-col v-if="form.tripType == 2" cols="12" sm="6" :md="form.tripType == 2 ? '3' : '2'">
      <v-menu v-model="returnmenuDate" :close-on-content-click="false" transition="scale-transition" offset-y
        min-width="auto">
        <template #activator="{ props }">
          <v-text-field v-model="returnformattedOutstationDate" label="Return Date" readonly v-bind="props"
            variant="outlined" color="#005886" required>
            <template #prepend-inner>
              <v-icon style="color: #005886">mdi-calendar</v-icon>
            </template>
          </v-text-field>
        </template>
        <v-date-picker v-model="form.returnDate" :min="getTodayLocal()" @update:modelValue="onReturnDateSelected"
          hide-actions />
      </v-menu>
    </v-col>

    <!-- Time -->
    <v-col cols="12" sm="6" :md="form.tripType == 2 ? '3' : '2'">
      <v-text-field v-model="form.startTime" label="Departure Time" type="time" variant="outlined" color="#005886"
        required>
        <template #prepend-inner>
          <v-icon style="color: #005886">mdi-clock</v-icon>
        </template>
      </v-text-field>
    </v-col>
    <v-col v-if="form.tripType == 2" cols="12" sm="6" :md="form.tripType == 2 ? '3' : '2'">
      <v-text-field v-model="form.returnTime" label="Return Time" type="time" variant="outlined" color="#005886"
        required>
        <template #prepend-inner>
          <v-icon style="color: #005886">mdi-clock</v-icon>
        </template>
      </v-text-field>
    </v-col>
  </v-row>
  <v-row class="standard-trip-options" :class="{ hidden: !isMultiCityEnabled }" id="standard-trip-options">
    <!-- From -->
    <v-col cols="12" sm="6" md="4">
      <v-autocomplete v-model="form.sourceAddress" :items="pickupSuggestions" :loading="pickupLoading"
        :list-props="{ class: 'custom-list', maxWidth: 385 }" label="From" placeholder="Enter Pickup Location"
        variant="outlined" hide-no-data no-filter item-title="description" item-value="place_id"
        @update:search="fetchPickupSuggestions" @update:modelValue="onPickupSelected" return-object>
        <template #prepend-inner>
          <v-icon style="color: #005886">mdi-map-marker</v-icon>
        </template>
      </v-autocomplete>
    </v-col>

    <!-- To -->
    <v-col cols="12" sm="6" md="4">
      <v-autocomplete v-model="form.destinationAddress" :items="dropSuggestions" :loading="pickupLoading"
        :list-props="{ class: 'custom-list', maxWidth: form.tripType == 2 ? 590 : 385 }" label="To"
        placeholder="Enter Drop Location" variant="outlined" hide-no-data no-filter item-title="description"
        item-value="place_id" @update:search="fetchDropSuggestions" @update:modelValue="onDropSelected" clearable
        return-object>
        <template #prepend-inner>
          <v-icon style="color: #005886">mdi-map-marker</v-icon>
        </template>
      </v-autocomplete>
    </v-col>

    <!-- Date -->
    <v-col cols="12" sm="6" md="2">
      <v-menu v-model="multimenuDate" :close-on-content-click="false" transition="scale-transition" offset-y
        min-width="auto">
        <template #activator="{ props }">
          <v-text-field v-model="multicityformattedOutstationDate" label="Departure Date" readonly v-bind="props"
            variant="outlined" color="#005886" required>
            <template #prepend-inner>
              <v-icon style="color: #005886">mdi-calendar</v-icon>
            </template>
          </v-text-field>
        </template>
        <v-date-picker v-model="form.startDate" :min="getTodayLocal()" @update:modelValue="onDateSelected"
          hide-actions />
      </v-menu>
    </v-col>

    <!-- Time -->
    <v-col cols="12" sm="6" md="2">
      <v-text-field v-model="form.startTime" label="Departure Time" type="time" variant="outlined" color="#005886"
        required>
        <template #prepend-inner>
          <v-icon style="color: #005886">mdi-clock</v-icon>
        </template>
      </v-text-field>
    </v-col>
    <v-col cols="12" class="d-flex justify-center">
      <v-btn type="button" color="primary" @click="addCity">
        <v-icon left>mdi-plus</v-icon>Add City
      </v-btn>
    </v-col>
  </v-row>
  <!-- Trip Plan Preview (Horizontal Row) -->
  <v-card class="pa-4 border-sm" elevation="0" v-if="ShowPaths && form.tripType == 3">
    <!-- Header -->
    <div class="d-flex justify-space-between align-start">
      <div class="text-body-1 font-weight-medium">
        Your trip plan: {{ duration }} day
      </div>
      <v-icon size="20">mdi-close</v-icon>
    </div>

    <!-- Timeline Section -->
    <div class="d-flex mt-4">
      <!-- Dot & Line Column -->
      <div class="d-flex flex-column align-center" style="width: 28px;">
        <template v-for="(item, index) in paths" :key="index">
          <!-- Dot -->
          <div :style="{
            width: '16px',
            height: '16px',
            borderRadius: '50%',
            backgroundColor: index === 0 ? '#1976D2' : '#43A047',
            border: '3px solid white',
            marginBottom: '8px'
          }"></div>

          <!-- Vertical Line -->
          <div v-if="index < paths.length - 1" style="
        width: 2px;
        background-color: #B0BEC5;
        flex-grow: 1;
        margin-bottom: 8px;
      "></div>
        </template>
      </div>

      <!-- Content Column -->
      <div class="flex-grow-1">
        <template v-for="(item, index) in paths" :key="index">
          <div class="d-flex justify-space-between" :class="index != 0 ? ' mt-7' : ''">
            <div>
              <div class="text-body-1 font-weight-medium text-start">
                {{ index === 0 ? item.sourceCityName : item.destinationCityName }}
              </div>
              <div class="text-body-2 text-medium-emphasis text-start">
                {{ index === 0 ? item.sourceAddress : item.destinationAddress }}
              </div>
            </div>
            <div class="text-right">
              <div class="text-caption text-medium-emphasis">
                {{ formatLeaving(item.startDate, item.startTime) }}
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>


    <!-- Footer -->
    <div class="d-flex justify-space-between align-center mt-6 text-body-2 text-medium-emphasis">
      <div>Date: {{ form.cities && form.cities.length > 0 ? formatDate(form.cities[0].startDate) : '' }}</div>
      <div>Duration: ~{{ duration }} day</div>
      <div>Stops: {{ paths.length - 1 }}</div>
    </div>
  </v-card>
</template>

<script>
// import { useDisplay } from 'vuetify';
export default {
  // setup() {
  //   const { smAndDown } = useDisplay()
  //   return { smAndDown }
  // },
  name: "OutstationForm",
  props: {
    modelValue: { type: Object, required: true },
    pickupSuggestions: Array,
    dropSuggestions: Array,
    pickupLoading: Boolean,
  },
  emits: [
    "update:modelValue",
    "fetchPickupSuggestions",
    "fetchDropSuggestions",
    "pickupSelected",
    "dropSelected",
    'dateSelected'
  ],
  data() {
    return {
      isMultiCityEnabled: false,
      ShowPaths: false,
      paths: [],
      menuDate: false,
      returnmenuDate: false,
      multimenuDate: false,
      maxSegments: 10,
      formattedOutstationDate: "",
      returnformattedOutstationDate: "",
      multicityformattedOutstationDate: "",
      duration:"1",
      sampleCities: [
        "Delhi",
        "Mumbai",
        "Bangalore",
        "Chennai",
        "Kolkata",
        "Hyderabad",
        "Pune",
        "Goa",
        "Jaipur",
        "Ahmedabad",
      ],
    };
  },
  computed: {
    form: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },
  watch: {
    'form.tripType'(val) {
      this.form.sourceAddress = '';
      if (val == '3') {
        this.isMultiCityEnabled = true
      } else {
        this.isMultiCityEnabled = false
      }
    },
  },
  methods: {
    addCity() {
      const lastCity = this.form.cities[this.form.cities.length - 1];

      this.form.destinationAddress = '';
      this.form.destinationName = '';

      this.form.sourceAddress = lastCity.destinationAddress;
      this.form.sourceName = lastCity.destinationName;
      this.form.sourceLat = lastCity.destinationLat;
      this.form.sourceLong = lastCity.destinationLong;
      this.form.sourceCityName = lastCity.destinationCityName;
      this.form.sourceStateName = lastCity.destinationStateName;

      if (this.form.cities.length > 0 && this.form.cities[0]?.destinationAddress != null) {
        this.ShowPaths = true
      }
      this.timelineLocations()
      this.tripDuration()
      // this.$emit("update:modelValue", { ...this.form });
    },
    tripDuration() {
      const cities = this.form.cities;
      if (cities.length == 1) return;

      const startDate = new Date(cities[0].startDate);
      const endDate = new Date(cities[cities.length - 1].startDate);

      const diffTime = endDate - startDate;
      const diffDays = Math.max(
        1,
        Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1 
      );

      this.duration = diffDays;
    },
    // addCity() {
    //   this.form.cities.push(this.createCitySegment());
    //   this.$emit("update:modelValue", { ...this.form });
    // },
    removeCity(index) {
      this.form.cities.splice(index, 1);
      this.$emit("update:modelValue", { ...this.form });
    },
    formatDateLocal(date) {
      return (
        date.getFullYear() +
        "-" +
        String(date.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(date.getDate()).padStart(2, "0")
      );
    },
    formatDate(dateString) {
      if (!dateString) return '';
      
      const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];

      const [year, month, day] = dateString.split('-');
      const monthName = months[parseInt(month, 10) - 1]; // Month is 0-indexed
      return `${monthName} ${parseInt(day, 10)}, ${year}`;
    },

    getTodayLocal() {
      const today = new Date();
      return this.formatDateLocal(today);
    },
    onDateSelected(val) {
      if (this.form.tripType != 3) {
        this.menuDate = false;
      } else {
        this.multimenuDate = false;
      }
      if (val) {
        const date = new Date(val);
        const formattedDate = this.formatDateLocal(date);
        this.form.startDate = formattedDate;
        if (this.form.tripType != 3) {
          this.formattedOutstationDate = formattedDate;
        } else {
          this.multicityformattedOutstationDate = formattedDate;
        }
        this.$emit("dateSelected", formattedDate);
      }
    },
    onReturnDateSelected(val) {
      this.returnmenuDate = false;
      if (val) {
        const date = new Date(val);
        const formattedDate = this.formatDateLocal(date);
        this.form.returnDate = formattedDate;
        this.returnformattedOutstationDate = formattedDate;
        this.$emit("update:modelValue", { ...this.form });
      }
    },
    onCityDateSelected(index, val) {
      if (val) {
        const date = new Date(val);
        const formattedDate = this.formatDateLocal(date);
        this.form.cities[index].startDate = formattedDate;
        this.$emit("update:modelValue", { ...this.form });
      }
      this.form.cities[index].menuDate = false;
    },
    formatLeaving(dateString, timeString) {
      if (!dateString) return '';

      const date = new Date(`${dateString}T${timeString}`);

      // Format time
      let hours = date.getHours();
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12 || 12; // convert 0 => 12

      // Format date
      const options = { month: 'long', day: 'numeric', year: 'numeric' };
      const formattedDate = date.toLocaleDateString('en-US', options);

      return `Leaving: ${hours}:${minutes} ${ampm} - ${formattedDate}`;
    },
    timelineLocations() {
      const locations = [];
      if (this.form.cities.length > 0) {
        // First object has source and destination
        locations.push({
          sourceCityName: this.form.cities[0].sourceCityName,
          sourceAddress: this.form.cities[0].sourceAddress,
          startDate: this.form.cities[0].startDate,
          startTime: this.form.cities[0].startTime
        });
        locations.push({
          destinationName: this.form.cities[0].destinationName,
          destinationCityName: this.form.cities[0].destinationCityName,
          destinationAddress: this.form.cities[0].destinationAddress,
          startDate: this.form.cities[1]?.startDate ?? '',
          startTime: this.form.cities[1]?.startTime ?? ''
        });

        // Add remaining destinations
        for (let i = 1; i < this.form.cities.length; i++) {
          locations.push({
            destinationName: this.form.cities[i].destinationName,
            destinationAddress: this.form.cities[i].destinationAddress,
            destinationCityName: this.form.cities[i].destinationCityName,
            startDate: this.form.cities[i + 1] ? this.form.cities[i + 1].startDate : '',
            startTime: this.form.cities[i + 1] ? this.form.cities[i + 1].startTime : ''
          });
        }
      }
      this.paths = locations;
    },
    fetchPickupSuggestions(query) {
      this.$emit("fetchPickupSuggestions", query);
    },
    fetchDropSuggestions(query) {
      this.$emit("fetchDropSuggestions", query);
    },
    onPickupSelected(val) {
      this.$emit("pickupSelected", val);
    },
    onDropSelected(val) {
      this.$emit("dropSelected", val);
    },
    getSegmentColor(index) {
      const colors = ["#003c71", "#005886", "#007BFF", "#FF6B6B", "#FFA500"];
      return colors[index % colors.length];
    },
  },
};
</script>

<style>
/* .trip-plan {
  border-left: 3px solid #003c71; 
  padding-left: 15px;
}
.trip-card {
  margin: 15px 0;
  position: relative;
  padding-left: 20px;
}
.trip-card-dot {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #003c71;
  position: absolute;
  left: -9px;
  top: 5px;
}
.trip-card-body {
  font-size: 14px;
  color: #333;
}
.trip-card-date {
  font-size: 12px;
  color: #666;
}
.trip-card-row {
  display: flex;
  align-items: center;
  margin: 2px 0;
}

.trip-card-row.arrow {
  font-weight: bold;
  font-size: 16px;
  margin-left: 5px;
}

.trip-start-label {
  font-size: 12px;
  color: #005886;
  margin-left: 5px;
}
.trip-plan-horizontal {
  overflow-x: auto;
  padding-bottom: 10px;
}

.trip-row {
  display: flex;
  align-items: center;
}

.trip-segment {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 120px;
  position: relative;
  margin: 0 10px;
}

.trip-dot {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  margin-bottom: 5px;
}

.trip-info {
  text-align: center;
  font-size: 14px;
  color: #333;
}

.trip-datetime {
  font-size: 12px;
  color: #666;
  margin-top: 3px;
}

.trip-arrow {
  font-size: 20px;
  color: #005886;
  margin: 0 10px;
  align-self: center;
} */

.timeline {
  border-left: 3px solid #005886;
  margin-left: 15px;
  padding-left: 15px;
}

.timeline-item {
  position: relative;
  margin-bottom: 20px;
}

.timeline-dot {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  position: absolute;
  left: -22px;
  top: 5px;
}

.timeline-content {
  font-size: 20px;
  color: #333;
}

.city-name {
  font-weight: bold;
  margin-bottom: 3px;
}

.datetime,
.eta {
  font-size: 15px;
  color: #666;
}

.trip-summary {
  margin-top: 10px;
  font-size: 15px;
  font-weight: 500;
  color: #444;
}

.next-btn-wrapper {
  margin-top: 20px;
}

.next-btn {
  background: #ff6600 !important;
  color: #fff !important;
  font-weight: bold;
}
</style>
